import { useTranslation } from 'react-i18next';
import { REGIONAL_RISK_ABIOTIC_STRESS_TAG, REGIONAL_RISK_ABIOTIC_STRESS_TAG_NAME } from '../../domain/tests-id.constants';
import type { StressRiskLevel } from '../../abiotic-stress/domain/abiotic-stress.models';
import { Container, Text } from './abiotic-stress-tag.styles';
import { getStressLabel, getStressTextColor, isValidStressRiskLevel } from './abiotic-stress-tag.utils';
import { ThermometerIcon } from '@protector/icons';

interface AbioticStressTagProps {
  stressRiskLevel: StressRiskLevel;
}

export const AbioticStressTag = ({ stressRiskLevel }: AbioticStressTagProps) => {
  const [t] = useTranslation();

  if (!isValidStressRiskLevel(stressRiskLevel)) {
    return null;
  }

  return (
    <Container $stressRiskLevel={stressRiskLevel} data-testid={REGIONAL_RISK_ABIOTIC_STRESS_TAG}>
      <ThermometerIcon style={{ color: getStressTextColor(stressRiskLevel) }} />
      <Text $stressRiskLevel={stressRiskLevel} data-testid={REGIONAL_RISK_ABIOTIC_STRESS_TAG_NAME}>
        {t(getStressLabel(stressRiskLevel))}
      </Text>
    </Container>
  );
};
